import { Badge } from "@/shared/components/ui/badge";
import { cn } from "@/shared/lib/utils";

// Marks a control that is visible but not wired up yet.
export function ComingSoonBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "border-muted-foreground/20 text-muted-foreground h-5 shrink-0 px-1.5 text-[10px] font-semibold tracking-normal normal-case",
        className,
      )}
    >
      Coming soon
    </Badge>
  );
}
